import axios from "axios";
import { getConfig } from "../../../../ApiHelpers/ApiDefaultConfig";
import { Button } from "./models";

export const fetchButtons = async (): Promise<Button[]> => {
    let config = getConfig()
    let result: Button[] = []
    try {
        await axios.get(`/getButtons`, config)
            .then((res) => {
                result = res.data || []
            })
    } catch (error) {
        console.log(error)
    }

    return result as Button[]
}


export const fetchStaticButton = async (static_name: string): Promise<Button> => {
    let config = getConfig()
    let result: Button = {
        id: '',
        name: '',
        category: '',
        createdAt: '',
        updatedAt: '',
        OwnerId: '',
        Messages: []
    }
    try {


        await axios.post(`/getStaticButton`, { name: static_name }, config)
            .then((res) => {
                result = res.data || []
            })
    } catch (error) {
        console.log(error)
    }

    return result
}


